import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';

const KPICard = ({
  title,
  value,
  unit = '',
  trend,
  trendDirection,
  invertTrendColor = false,
  subtitle
}) => {
  const isPositive = invertTrendColor
    ? trendDirection === 'down'
    : trendDirection === 'up';

  const trendColor = isPositive ? '#4caf50' : '#f44336';
  const TrendIcon = trendDirection === 'up' ? TrendingUpIcon : TrendingDownIcon;

  const formatValue = (val) => {
    if (val === null || val === undefined) return '-';
    if (unit === '€') return `${val.toFixed(2)} €`;
    if (unit === '%') return `${val.toFixed(1)}%`;
    return val.toLocaleString('fr-FR');
  };

  return (
    <Card style={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary">
          {title}
        </Typography>
        <Typography variant="h4" style={{ marginTop: 8, marginBottom: 8 }}>
          {formatValue(value)}
        </Typography>
        {trend !== undefined && trend !== null && (
          <Box display="flex" alignItems="center" style={{ color: trendColor }}>
            <TrendIcon style={{ fontSize: 20, marginRight: 4 }} />
            <Typography variant="body2">
              {trend > 0 ? '+' : ''}{trend.toFixed(1)}%
            </Typography>
          </Box>
        )}
        {subtitle && (
          <Typography variant="caption" color="textSecondary" style={{ marginTop: 4, display: 'block' }}>
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default KPICard;
